import { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { Home, Dumbbell, UtensilsCrossed, CalendarDays, User } from 'lucide-react';

const navItems = [
  { to: '/', icon: Home, label: 'Accueil' },
  { to: '/entrainement', icon: Dumbbell, label: 'Training' },
  { to: '/nutrition', icon: UtensilsCrossed, label: 'Nutrition' },
  { to: '/hub', icon: CalendarDays, label: 'Evenements' },
  { to: '/profil', icon: User, label: 'Profil' },
];

export function BottomNav() {
  return (
    <nav
      className="fixed bottom-0 left-0 right-0 bg-[#0F0F0F]/95 backdrop-blur-xl border-t border-[#2A2A2E] z-50"
      data-testid="bottom-navigation"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
    >
      <div className="flex justify-around items-center h-16 max-w-lg mx-auto">
        {navItems.map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            end={to === '/'}
            data-testid={`nav-${label.toLowerCase()}`}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-0.5 min-w-[56px] min-h-[44px] px-2 py-1.5 transition-colors ${
                isActive ? 'text-[#FF6B35]' : 'text-[#888888] active:text-[#CCCCCC]'
              }`
            }
          >
            <Icon className="w-5 h-5" strokeWidth={1.8} />
            <span className="text-[10px] font-semibold tracking-wide">{label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
